import React from 'react'

import { useLoaderData } from 'react-router-dom'

import CategorySection from '@components/music/CategoryList/CategorySection'
import { MusicCategoriesResponse } from '@pages/music/loaders/categories.loader'

const CategoryList: React.FC = () => {
  const data = useLoaderData() as MusicCategoriesResponse
  return (
    <>
      {data.categories?.map((facet) => (
        <CategorySection facet={facet} key={facet.category} />
      ))}
    </>
  )
}

export default CategoryList
